/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */
import Blowfish from 'es6-sladex-blowfish';
import Toast from '../components/shared/Toast';
import {
  LOCALSTORAGE_ID,
  LOCALADMIN_DATA,
  LOCALADMIN_JWT,
  LOCALCLIENT_DATA,
  LOCALCLIENT_JWT,
  LOCALSYSTEM_DATA,
  LOCALSYSTEM_JWT,
  REACT_PACE_KEY,
} from '../constants/localConfig';
import { loggerFn } from './loggerUtil';
import { mainStore } from '..';
import { clearKeyRequet, updateKeyRequest, updateSingleKeyRequest } from '../pages/duck/key/actions';

const DEFAULT_LOCAL_OBJ = {
  [LOCALADMIN_DATA]: '{}',
  [LOCALADMIN_JWT]: '',
  [LOCALCLIENT_DATA]: '{}',
  [LOCALCLIENT_JWT]: '',
  [LOCALSYSTEM_DATA]: '{}',
  [LOCALSYSTEM_JWT]: '',
};

const getLevelKeynameByKey = key => {
  if (key.includes('-token')) {
    if (key.includes('-client-')) {
      return {
        level: LOCALCLIENT_JWT,
        keyName: undefined,
      };
    } else if (key.includes('-admin-')) {
      return {
        level: LOCALADMIN_JWT,
        keyName: undefined,
      };
    } else {
      return {
        level: LOCALSYSTEM_JWT,
        keyName: undefined,
      };
    }
  } else {
    if (key.includes('-client-')) {
      return {
        level: LOCALCLIENT_DATA,
        keyName: key,
      };
    } else if (key.includes('-admin-')) {
      return {
        level: LOCALADMIN_DATA,
        keyName: key,
      };
    } else {
      return {
        level: LOCALSYSTEM_DATA,
        keyName: key,
      };
    }
  }
};

const getPacesetterLocalstorage = () => {
  let localData = localStorage.getItem(LOCALSTORAGE_ID);

  if (!localData) {
    localStorage.setItem(LOCALSTORAGE_ID, JSON.stringify(DEFAULT_LOCAL_OBJ));
    return DEFAULT_LOCAL_OBJ;
  }
  return JSON.parse(localData);
};

const setPacesetterLocalstorage = data => {
  localStorage.setItem(LOCALSTORAGE_ID, JSON.stringify(data));

  return true;
};

const getPacesetterLevelLocalstorage = (level, keyName) => {
  let parsedData = undefined;
  let pacesetterLocalstorage = getPacesetterLocalstorage();
  if (!pacesetterLocalstorage) {
    return false;
  }

  let encryptedData = pacesetterLocalstorage[level];
  if (!encryptedData) {
    return false;
  }

  if (encryptedData === '{}' || encryptedData === '') {
    return JSON.parse(encryptedData);
  } else {
    if (keyName) {
      try {
        // parsedData = JSON.parse(Blowfish.decrypt(encryptedData, REACT_PACE_KEY));
        parsedData = JSON.parse(encryptedData);
      } catch (e) {
        throw new Error(`Error when parsing the storage data at level ${level} and key ${keyName}. - ${encryptedData}`)
      }
      if (!parsedData) {
        return false;
      }
    } else {
      parsedData = encryptedData;
    }

    return parsedData;
  }
};

const setPacesetterLevelLocalstorage = (level, keyName, dataToBeEncrypted) => {
  let encryptedData = undefined;
  if (keyName) {
    try {
      // encryptedData = Blowfish.encrypt(dataToBeEncrypted, REACT_PACE_KEY);
      encryptedData = dataToBeEncrypted;
    } catch (e) {
      throw new Error(`Failed to encrypt data for key "${keyName}" in localStorage at level "${level}". - ${dataToBeEncrypted}`)
    }
  } else {
    encryptedData = dataToBeEncrypted;
  }

  let pacesetterLocalstorage = getPacesetterLocalstorage();

  pacesetterLocalstorage[level] = encryptedData;

  setPacesetterLocalstorage(pacesetterLocalstorage);
};

const getPacesetterLevelLocalstorageByKey = key => {
  const { level, keyName } = getLevelKeynameByKey(key);

  let parsedData = getPacesetterLevelLocalstorage(level, keyName);

  if (parsedData instanceof Object) {
    if (!parsedData[keyName]) {
      return false;
    }

    return parsedData[keyName];
  } else {
    return parsedData;
  }
};

const setPacesetterLocalstorageByKeyValue = (key, value) => {
  const { level, keyName } = getLevelKeynameByKey(key);
  let parsedData = undefined;

  parsedData = getPacesetterLevelLocalstorage(level, keyName);

  if (parsedData instanceof Object) {
    parsedData[keyName] = value;
    parsedData = JSON.stringify(parsedData);
  } else {
    parsedData = value;
  }

  setPacesetterLevelLocalstorage(level, keyName, parsedData);
};

/**
 * Store string record in the storage
 *
 * @param {string} key
 * @param {string | array | object} value
 */
export let setLocalStorage = (key, value) => {
  mainStore.dispatch(updateSingleKeyRequest({ [key]: value }));

  try {
    setPacesetterLocalstorageByKeyValue(key, value);
  } catch (error) {
    loggerFn(error.message)
    // localStorage.clear(REACT_PACE_KEY);
    // Toast(
    //   'Due to suspicious activity in authentication, you have been logged out. Please login.',
    //   'WARNING'
    // );
  }
};

/**
 * Retrieve record from the storage using the key
 *
 * @param {string} key
 */
export let getLocalStorage = key => {
  const keys = mainStore.getState().key.payload

  if (keys[key]) {
    return keys[key]
  }

  // try {
  //   let valueFromLocalStorage = getPacesetterLevelLocalstorageByKey(key)
  //   mainStore.dispatch(updateSingleKeyRequest({ [key]: valueFromLocalStorage }));
  //   return valueFromLocalStorage;
  // } catch (error) {
  //   loggerFn(error.message)
  //   localStorage.clear(REACT_PACE_KEY);
  //   Toast(
  //     'Due to suspicious activity in authentication, you have been logged out. Please login.',
  //     'WARNING'
  //   );
  // }
};

/**
 * Clear records from the storage using the key
 *
 * @param {string} key
 */
export let clearLocalStorage = key => {
  mainStore.dispatch(updateSingleKeyRequest({ [key]: undefined }));

  setPacesetterLocalstorageByKeyValue(key, undefined);
};

export let clearLocalStorage2 = key => {
  localStorage.clear()
  mainStore.dispatch(clearKeyRequet());
};

export let setLocalStorageBulk = arrayOfObjectWithKeyValue => {
  const { level, keyName } = getLevelKeynameByKey(arrayOfObjectWithKeyValue[0].key);
  let parsedData = undefined;

  parsedData = getPacesetterLevelLocalstorage(level, keyName);

  arrayOfObjectWithKeyValue.forEach(({ key, value }, index) => {
    parsedData[key] = value;
  });

  mainStore.dispatch(updateKeyRequest(parsedData));
  parsedData = JSON.stringify(parsedData);

  setPacesetterLevelLocalstorage(level, keyName, parsedData);
};
